export class RestoreDynamoDBToExistingTableRequest {
    'restoreAccountId';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "DynamodbTableRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreDynamoDBToExistingTableRequest.attributeTypeMap;
    }
    constructor() {
    }
}
